module.exports = __webpack_public_path__ + "static/media/tourCreditCards.64531656.svg";